import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_TEXTURE = "https://images.unsplash.com/photo-1615729947596-a598e5de0ab3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx1cGxhbmQlMjBtb3VudGFpbiUyMG5hdHVyZSUyMGFic3RyYWN0fGVufDB8fHx8MTc4MjcwNTY1M3ww&ixlib=rb-4.1.0&q=80&w=1920";

export default function Hero({ content, onBook }) {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen bg-upland-green text-upland-creme overflow-hidden flex items-end">
      <div className="absolute inset-0 opacity-25" style={{ backgroundImage: `url(${HERO_TEXTURE})`, backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0 grain opacity-[0.07]" />
      <div className="absolute inset-0 bg-gradient-to-t from-upland-green via-upland-green/40 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-24 pt-40 w-full">
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
          className="text-xs uppercase tracking-[0.3em] text-upland-creme/70 mb-3">
          {content.hero_overline}
        </motion.p>
        {content.hero_est && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.08 }}
            className="text-xs uppercase tracking-[0.3em] text-upland-creme/50 mb-8">
            {content.hero_est}
          </motion.p>
        )}

        <motion.h1
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          data-testid="hero-title"
          className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-4xl">
          {(content.hero_title || "").split(/(\bpace\b)/i).map((part, i) =>
            /^pace$/i.test(part)
              ? <em key={i} className="italic font-bold">{part}</em>
              : part
          )}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.4 }}
          className="mt-8 max-w-xl text-lg md:text-xl text-upland-creme/80 leading-relaxed font-light">
          {content.hero_subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.6 }}
          className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <button data-testid="hero-book-btn" onClick={onBook}
            className="bg-upland-creme text-upland-green text-base px-10 py-4 hover:bg-white transition-colors duration-300 tracking-wide">
            {content.hero_cta}
          </button>
          <a href="#services" className="text-upland-creme/80 text-sm flex items-center gap-2 link-underline">
            Explore our work <ArrowDown size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
